<!-- 閲覧専用ユーザのパーミッション設定 -->
<template>
  <div class="pt-1">
  <div v-if="userRole!==rootRoleName && userRole!==viewerRoleName">
  <v-btn
    small
    depressed
    id="viewer-permission-edit-btn"
    class="teal lighten-1 white--text"
    @click.native.stop="startDialog"
  >
      {{$t('viewable-locations.button-add-viewable-locations')}}
    </v-btn>
    </div>
    <v-dialog
      v-model="showDialog"
      max-width="700px"
      persistent
    >
      <v-card class="pa-3">
        <v-form
          v-model="validated"
          ref="viewerPermissionForm">

          <v-layout>
            <v-flex xs9 class="px-0 py-2">
              <v-subheader class="">{{$t("viewable-locations.label-viewing-target-locations")}}</v-subheader>
            </v-flex>
            <v-flex xs12 class="pa-2">
              <v-select
                :label="$t('viewable-locations.label-viewing-target-locations')"
                v-model="edit.accountGroupResourceIds.viewLocation"
                :items="locations"
                item-text="locationName"
                item-value="locationId"
                multiple
                max-height="300"
                :hint="$t('viewable-locations.hint-viewing-target-locations')"
                persistent-hint
              ></v-select>
            </v-flex>
          </v-layout>

          <v-layout>
              <v-spacer></v-spacer>
              <v-btn
                flat
                @click.native="showDialog=false"
              >
                {{$t('viewable-locations.button-cancel')}}
              </v-btn>

              <v-btn
                color="primary"
                class="ml-4"
                @click.prevent="setVisibleLocations"
                :disabled="btnDisable||!validated"
              >
                {{$t('viewable-locations.button-set')}}
              </v-btn>
          </v-layout>
          <!-- errors -->
          <div v-if="errorMessage" class="red--text">
            <strong>{{errorMessage}}</strong>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import config from '@/config.js'
import http from '@/utils/http.js'
import validate from '@/utils/validate.js'
import MapModal from '@/components/MapModal.vue'

export default {
  components: {
    MapModal
  },
  props: ['editProp'],
  data () {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: config.role.Root,
      viewerRoleName: config.role.Viewer,
      edit: {},
      validated: false,
      locations: [],
      errorMessage: '',
      showDialog: false,
      showMap: false,
      btnDisable: false,
      phoneRules: [
        v => validate.phoneFormat(v) ||
        this.$t('validate.phone-format'),
        v => v.length <= 128 || this.$t('validate.phone-length')
      ]
    }
  },
  watch: {
  },
  methods: {
    init () {
      this.edit = JSON.parse(JSON.stringify(this.editProp))
      if (this.edit.accountGroupResourceIds === undefined) {
        this.edit.accountGroupResourceIds = {viewLocation: []}
      }
      this.getLocations()
    },
    getLocations () {
      http.request('get', '/service2/dashboard/api/Organizations/locationList/' + this.edit.organizationId)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get location list failed. (' + data.result + ')')
            return
          }
          this.locations = data.locations
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    startDialog (edit) {
      this.$refs.viewerPermissionForm.reset() // 一旦バリデーション等をリセット
      this.init()
      this.errorMessage = ''
      this.showMap = false
      this.btnDisable = false
      this.showDialog = true
    },
    setVisibleLocations () {
      this.btnDisable = true // ボタン無効化
      this.$emit('child-action', this.edit)
      this.btnDisable = true
      this.showDialog = false
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style>

#maps {
  -webkit-transition: width 300ms ease, height 300ms ease;
  transition: width 300ms ease, height 300ms ease;
}

#customer-add-btn {
  border-radius: 0px;
}

 </style>



// WEBPACK FOOTER //
// AccountVisibleLocationsSetDialog.vue?4601f9c6